export default {
    methods: {
        convertFromLocalTimezone(date, dailyFormat) {
            if (dailyFormat){
                return this.$moment.tz(date, this.$moment.tz.guess()).utc().format('YYYY-MM-DD')
            }
            return this.$moment.tz(date, this.$moment.tz.guess()).utc().format('YYYY-MM-DD HH:mm')
        },
        
        convertFromUtcTimezone(date, dailyFormat) {
            if (dailyFormat){
                return this.$moment(date).local().format('YYYY-MM-DD');

            }
            return this.$moment(date).local().format('YYYY-MM-DD HH:mm');
        }
    },
    data() {
        return {
        }
    }
}
